import { FC } from "react";
import { Box, Typography } from "@mui/material";
import { DataGrid } from "../../../../components/datagrid";
import { useCompletedBrokerColumns } from "./hooks/useCompletedBrokerColumns";
import { useCompletedBrokerOverview } from "../../dataHooks/brokerQueries";
import { useRoles } from "../../../../auth/useRoles";
import {
  hasAnyAppRole,
  isGlobalLifecycleRole
} from "../../../../auth/permissions";

type Props = {};

export const CompletedBrokersGrid: FC<Props> = () => {
  const { data, isLoading, isFetching } = useCompletedBrokerOverview();

  const rows = data || [];
  const roles = useRoles();
  const columns = useCompletedBrokerColumns(rows, isGlobalLifecycleRole(roles));
  const showGrantModeEmptyState =
    !isLoading && !isFetching && rows.length === 0 && !hasAnyAppRole(roles);

  if (showGrantModeEmptyState) {
    return (
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center"
        }}
      >
        <Typography variant="h6">
          You do not have access to any completed brokers yet.
        </Typography>
      </Box>
    );
  }

  return (
    <DataGrid
      loading={isLoading || isFetching}
      columns={columns}
      rows={rows}
      getRowId={(row) => row.id}
      getRowHref={(row) => `/brokers/broker/${row.id}`}
      searchPlaceholder="Search completed brokers"
      exportFileName="Completed brokers"
      initialState={{
        sorting: {
          sortModel: [
            {
              field: "signOffCompletedAt",
              sort: "desc"
            }
          ]
        }
      }}
      sx={{
        "&.MuiDataGrid-root .MuiDataGrid-cell:focus": {
          outline: "none"
        }
      }}
    />
  );
};
